import { languageService } from "../../../../Language/language.service";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { TableCellScrollable } from "../../Helper/TableUtils";
import React from "react";
import moment from "moment";

export const hosPreviouslyServedHoursTableSchema = [
  {
    Header: languageService("Duty Type"),
    accessor: "dutyType",
    id: "dutyType",
    minWidth: 125,
  },
  {
    Header: languageService("Service Type"),
    accessor: "serviceType",
    id: "serviceType",
    minWidth: 125,
  },
  {
    Header: languageService("Location"),
    id: "location",
    accessor: (d) => {
      const startLoc = d.startLoc ? d.startLoc.description : "";
      const endLoc = d.endLoc ? d.endLoc.description : "";
      return `${startLoc} - ${endLoc}`;
    },
    minWidth: 125,
  },
  {
    Header: languageService("Start Date & Time"),
    id: "startDate",
    accessor: "startDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 100,
  },
  {
    Header: languageService("End Date & Time"),
    id: "endDate",
    accessor: "endDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 100,
  },
  {
    Header: languageService("Duration (HH:mm)"),
    accessor: (d) => {
      let startDate = moment.tz(d.startDate, d.timezone);
      let endDate = moment.tz(d.endDate, d.timezone);
      return dataFormatters.formatTimeDuration(endDate.diff(startDate, "ms"), false);
    },
    id: "duration",
    minWidth: 80,
  },
  {
    Header: languageService("Activity"),
    accessor: "activityType.value",
    id: "activityType",
    minWidth: 130,
  },
  {
    Header: languageService("Comments"),
    accessor: "comments",
    id: "comments",
    minWidth: 275,
    Cell: TableCellScrollable,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/schemas/hosPreviouslyServedHoursTableSchema.js